import { PaginationMetadata } from '@execonline-inc/resource';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { PER_PAGE } from '../Store/Types';

interface Props {
  metadata: PaginationMetadata;
  shown: number;
}

function Summary({ metadata, shown }: Props) {
  const first = (metadata.currentPage - 1) * PER_PAGE + 1;

  return (
    <p className="text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
      <T
        kind="Showing {{first}}-{{last}} of {{total}}"
        first={first.toLocaleString()}
        last={(first + shown - 1).toLocaleString()}
        total={metadata.resultsCount.toLocaleString()}
      />
    </p>
  );
}

export default observer(Summary);
